import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PreviousRouteService } from 'src/app/services/previousRouteService';

/**
 * PagenotfoundComponent
 * 
 * A presentational component that displays a 404 Page Not Found error page.
 * This component is shown when users navigate to invalid or non-existent routes
 * in the application.
 * 
 * Component features:
 * - Displays user-friendly 404 error message
 * - Tracks navigation history for back button functionality
 * - Responsive error page layout
 * - Route tracking for previous page reference
 * 
 * Navigation flow:
 * 1. User navigates to invalid route
 * 2. Route guard/routing module displays this component
 * 3. Component tracks current route in navigation history
 * 4. User can navigate back to previous page
 * 
 * @component
 * @selector app-pagenotfound
 * @example
 * <app-pagenotfound></app-pagenotfound>
 * 
 * @implements {OnInit}
 * @author Generated by CompDoc
 * @version 1.0.0
 */
@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent implements OnInit {

  /**
   * Constructor for PagenotfoundComponent
   * 
   * Initializes the 404 error page component with dependencies for route tracking.
   * 
   * Dependencies:
   * - LocationStrategy: Used to get the current browser location/path
   * - PreviousRouteService: Service for managing and tracking navigation history
   * 
   * @constructor
   * @param {LocationStrategy} locationStrategy - Angular location strategy service for URL path retrieval
   * @service LocationStrategy - Provides current browser location information
   * @param {PreviousRouteService} previousRouteService - Service for tracking navigation history and previous routes
   * @service PreviousRouteService - Manages application-wide route history
   */
  constructor(private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService) {
  }

  /**
   * Angular lifecycle hook - Component initialization
   * 
   * Called once when the component is initialized. Performs navigation history tracking
   * by recording the current page (404 error page) in the previous route service.
   * This allows users to navigate back to the page they came from.
   * 
   * Execution flow:
   * 1. Component loads
   * 2. Gets current browser path from LocationStrategy
   * 3. Stores the path in PreviousRouteService for navigation tracking
   * 4. Allows back navigation functionality
   * 
   * @method ngOnInit
   * @returns {void}
   * @lifecycle Angular component initialization hook - Called once after component creation
   */
  ngOnInit() { 
    this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
  }

}
